module.exports = __webpack_public_path__ + "img/declare.e068aeb9.png";